module.exports = __webpack_public_path__ + "static/media/schema-logo.a371906d.png";